import React from 'react'
import AboutCard from '../About/AboutCard'

function Homeabout() {
  return (<>
  <section className="homeabout">
    <div className="conatainer top">
        <AboutCard/>
    </div>
  </section>
  </>
  )
}

export default Homeabout; 